/*! All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://github.com/Esri/calcite-design-system/blob/dev/LICENSE.md for details.
v3.0.3 */
const c = "24px", a = "32px", e = "44px", t = "48px";
export {
  a,
  e as b,
  c,
  t as d
};
